import {Flex} from '@freckle/educator-materials/ts/components/flex'
import {getTeacherReferralLink} from '@freckle/classroom/ts/common/logic/referrals'
import type {TeacherAttrs} from '@freckle/classroom/ts/users/models/teacher'
import type {ReferralAttrs} from '../models/referral'
import {Banner} from './banner'
import {ProgramDescription} from './program-description'
import {ReferralLink} from './referral-link'
import {ReferredInformation} from './referred-information'
import {topLevelContainer} from './referral-program.module.scss'

type Props = {
  teacher: TeacherAttrs
  referrals: Array<ReferralAttrs>
}

const ReferralProgramComponent = (props: Props): React.ReactElement => {
  const {teacher, referrals} = props
  const referralLink = getTeacherReferralLink(teacher)
  return (
    <Flex className={topLevelContainer} flexDirection="column">
      <Banner />
      <ReferralLink referralLink={referralLink} />
      <ProgramDescription />
      <ReferredInformation referrals={referrals} />
    </Flex>
  )
}

export {ReferralProgramComponent}
